import {Md5} from "ts-md5"

export class Utils {
    public static MD5(d: string): string {
        return String(Md5.hashStr(d, false))
    }
}